const config= {
  elements_selector: ".lazy"
};

export default config;
